import { Text } from '@/components';
import type { FC } from 'react';

type Props = {
  text: string;
};

export const PageTitle: FC<Props> = ({ text }) => {
  return (
    <Text
      variant="h4"
      style={{ margin: 0 }}
      text={text}
      ellipsis={{ tooltip: true }}
    />
  );
};
